<template>
  <IQOS :title="$t('worker_profile.tipping_title')" :enabled="true" required>
        <SlideToggleRow class="mt-16" :value="waiter.tipping_methods.cash" @input="toggleMethod('cash')">
            {{ $t('worker_profile.tipping_cash') }}
        </SlideToggleRow>
        <BaseDivider color="v1-grey-4" class="mt-16"/>
        <SlideToggleRow class="mt-16" :value="waiter.tipping_methods.online" @input="toggleMethod('online')">
            {{ $t('worker_profile.tipping_online') }}
        </SlideToggleRow>

        <div class="w-100 mt-16" v-if="waiter.tipping_methods.online">
            <p class="qrw-paragraph-md iqos-comment">
                {{ $t('worker_profile.tipping_merchant') }}
            </p>
            <BaseSelect class="w-100 mt-8" fullWidth :value="waiter.pay_receiver_id" @input="changePayReceiverId">
                <option :value="null" disabled> - </option>
                <option v-for="pay_receiver in pay_receivers" :value="pay_receiver._id" :key="pay_receiver._id">
                    {{ capitalize(pay_receiver.gateway) }} ({{ pay_receiver.company_name || pay_receiver.liqpay_public_key || pay_receiver.wayforpay_merchant }} )
                </option>
            </BaseSelect>
        </div>

        <BaseDivider color="v1-grey-4" class="mt-16"/>

        <p class="qrw-paragraph-md iqos-comment mt-16">
            {{ $t('worker_profile.tipping_comment') }}
        </p>
        
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue"

export default {
    props: {
        waiter: Object,
    },
    data() {
        return {
            editing: false,
            ready: false
        }
    },
    components: {
        SlideToggleRow,
    },
    methods: {
        showEditUI() {
            
        },
        hideEditUI() {
            this.editing = false;
        },
        reset() {

        },
        onEditFinish() {

        },
        toggleMethod(method) {
            this.waiter.tipping_methods[method] = !this.waiter.tipping_methods[method] ;
            
            this.$emit('saved', this.waiter);
        },
        capitalize(str) {
            return str.substring(0,1).toUpperCase() + str.substring(1);
        },
        changePayReceiverId(value) {
            this.waiter.pay_receiver_id = value;
            
            this.$emit('saved', this.waiter);
        }
    },
    computed: {
        pay_receivers() {
            return this.$store.state.pay_receivers;
        }
    },
    mounted() {
        this.ready = true;
    }
}
</script>

<style>

</style>